module.exports = __webpack_public_path__ + "img/ปลาคอด.76405b44.png";